import React, {useEffect} from "react";
import "./DailyBlogsPage.scss";
import {useLocation, useParams} from "react-router-dom";
import Blog5 from "./DailyBlogs/Blog5";
import Blog6 from "./DailyBlogs/Blog6";
import Blog7 from "./DailyBlogs/Blog7";
const DailyBlogsPage = () => {
  const {blogId} = useParams();
  console.log(blogId, "blogIdblogId");
  useEffect(() => {}, []);
  return (
    <div className="dailyBlogsPageContainer">
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 5 && <Blog5 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 6 && <Blog6 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 7 && <Blog7 />}</div>
    </div>
  );
};

export default DailyBlogsPage;
